import React from 'react';
import { useTranslation } from 'react-i18next';

const TopBar = () => {
  const { i18n, t } = useTranslation();
  const lang = (i18n.language || 'en').toLowerCase();
  const is = (code) => lang.startsWith(code);
  const change = (code) => {
    if (!is(code)) i18n.changeLanguage(code);
  };
  return (
    <div className="absolute top-0 left-0 right-0 z-50">
      <div className="container mx-auto px-6 py-3 flex items-center justify-end gap-6 text-sm">
        <div className="flex items-center gap-1 bg-white/10 border border-white/20 rounded-full p-1 shadow-sm backdrop-blur-sm">
          <button
            type="button"
            aria-pressed={is('en')}
            className={`px-3 py-1 rounded-full transition-colors ${is('en') ? 'bg-white/25 text-white font-semibold shadow' : 'text-white/70 hover:text-white'}`}
            onClick={() => change('en')}
          >
            EN
          </button>
          <button
            type="button"
            aria-pressed={is('nl')}
            className={`px-3 py-1 rounded-full transition-colors ${is('nl') ? 'bg-white/25 text-white font-semibold shadow' : 'text-white/70 hover:text-white'}`}
            onClick={() => change('nl')}
          >
            NL
          </button>
          <button
            type="button"
            aria-pressed={is('tr')}
            className={`px-3 py-1 rounded-full transition-colors ${is('tr') ? 'bg-white/25 text-white font-semibold shadow' : 'text-white/70 hover:text-white'}`}
            onClick={() => change('tr')}
          >
            TR
          </button>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
